import {
    createAction,
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

import OutputReportService from '../services/OutputReportService';
import { LOGOUT } from '../constants/actions/auth.constants';
import IBaseState from '../types/IBaseState';
import { Report } from '@tcc-online/output-report';

const NAME = 'Reports';

const getReports = createAsyncThunk(
    `${NAME}/getReports`,
    OutputReportService.getReports,
);

const getReport = createAsyncThunk(`${NAME}/getReport`, (reportId: number) =>
    OutputReportService.getReport(reportId),
);

const setDetailLoading = createAction<boolean>(`${NAME}/setDetailLoading`);

type ReportState = {
    list: IBaseState<Report[]>;
    detail: IBaseState<Report | null>;
};

const initialState: ReportState = {
    list: {
        data: [],
        loading: false,
    },
    detail: {
        data: null,
        loading: false,
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getReports.pending, (state) => {
            state.list.loading = true;
        });
        builder.addCase(getReports.fulfilled, (state, action) => {
            state.list.loading = false;
            state.list.data = action.payload.data;
        });
        builder.addCase(getReports.rejected, (state) => {
            state.list.loading = false;
        });
        builder.addCase(getReport.pending, (state) => {
            state.detail.data = null;
        });
        builder.addCase(getReport.fulfilled, (state, action) => {
            state.detail.data = action.payload.data;
        });
        builder.addCase(LOGOUT, (state) => {
            state.list.data = [];
            state.list.loading = false;
            state.detail.data = null;
            state.detail.loading = false;
        });

        builder.addCase(
            setDetailLoading.type,
            (state: ReportState, action: PayloadAction<boolean>) => {
                state.detail.loading = action.payload;
            },
        );
    },
});

const OutputReportActions = {
    getReports,
    getReport,
    setDetailLoading,
};

export default OutputReportActions;
export const OutputReportReducer = slice.reducer;
